import { REGEXP_ONLY_DIGITS } from "input-otp"
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp"
import { cn } from "@/lib"

export interface OtpInputProps {
  length?: number
  value?: string
  onChange?: (value: string) => void
  onComplete?: (value: string) => void
  disabled?: boolean
  error?: string
  autoFocus?: boolean
}

export function OtpInput({
  length = 6,
  value = "",
  onChange,
  onComplete,
  disabled = false,
  error,
  autoFocus = false,
}: OtpInputProps) {
  return (
    <div>
      <InputOTP
        maxLength={length}
        value={value}
        onChange={(newValue: string) => {
          onChange?.(newValue)
          if (newValue.length === length) {
            onComplete?.(newValue)
          }
        }}
        disabled={disabled}
        autoFocus={autoFocus}
        pattern={REGEXP_ONLY_DIGITS}
        inputMode="numeric"
      >
        <InputOTPGroup className="gap-2">
          {Array.from({ length }).map((_, index) => (
            <InputOTPSlot
              key={`otp-slot-${index}`}
              index={index}
              className={cn(
                "size-[45px] rounded-none border-b text-lg font-bold first:border-l-0 first:rounded-none last:rounded-none data-[active=true]:ring-0",
                error
                  ? "border-b-[#C33]"
                  : "border-b-[#F2F0EB33] data-[active=true]:border-b data-[active=true]:border-b-black",
              )}
            />
          ))}
        </InputOTPGroup>
      </InputOTP>
      {error && <p className="mt-2 text-xs text-brand-terracotta-bright text-center">{error}</p>}
    </div>
  )
}
